var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.5C10.6562 22.5 10 21.8438 10 21H8.5C8.5 22.6875 9.8125 24 11.5 24C13.1406 24 14.5 22.6875 14.5 21H13C13 21.8438 12.2969 22.5 11.5 22.5ZM21.2969 15.7031C19.9844 14.4844 19 13.1719 19 8.71875C19 5.01562 16 1.96875 12.25 1.59375V0.75C12.25 0.375 11.875 0 11.5 0C11.0781 0 10.75 0.375 10.75 0.75V1.59375C6.95312 1.96875 3.95312 5.01562 3.95312 8.71875C3.95312 13.1719 2.96875 14.4844 1.65625 15.7031C1 16.3594 0.8125 17.2969 1.14062 18.1406C1.46875 18.9844 2.3125 19.5 3.25 19.5H19.75C20.6406 19.5 21.4844 18.9844 21.8125 18.1406C22.1406 17.2969 21.9531 16.3594 21.2969 15.7031ZM19.75 18H3.25C2.54688 18 2.21875 17.25 2.6875 16.7812C4.32812 15.2344 5.45312 13.5 5.45312 8.71875C5.45312 5.57812 8.17188 3 11.5 3C14.7812 3 17.5 5.57812 17.5 8.71875C17.5 13.5 18.625 15.2344 20.2656 16.7812C20.7344 17.25 20.4062 18 19.75 18Z",
    fill: "#00C8D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlam);
export default __webpack_public_path__ + "static/media/alam.1fd394a898c2b96cbb22815e775f184c.svg";
export { ForwardRef as ReactComponent };